import { ExternalEntityTypeEnum } from '../enum/external-entity-type';
import { BillingProductDto } from './billing-product';

export class ExternalIdMapDto {
    internalId: number;
    externalId: string | null;
    externalEntityType: ExternalEntityTypeEnum;
    billingProductId: number;
    billingProduct?: BillingProductDto;
  }
  